// extracted by mini-css-extract-plugin
export default {"manager":"XManager_manager__1xsIj","xtitle":"XManager_xtitle__iheg9","xsubtitle":"XManager_xsubtitle__o90Xq"};